import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AddressFormGroup } from '../../../../../forms/address-form-group';

@Component({
  selector: 'app-head-office-address-form-grid',
  templateUrl: './head-office-address-form-grid.component.html',
  styleUrls: ['./head-office-address-form-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeadOfficeAddressFormGridComponent {
  @Input() form!: AddressFormGroup;
  @Input() formSubmitted = false;
  @Input() showTitle = true;
}
